var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview -page"},[_c('h2',[_vm._v(_vm._s(_vm.data.first_name)+" "+_vm._s(_vm.data.last_name))]),_c('p',[_vm._v("soon..")])])}
var staticRenderFns = []

export { render, staticRenderFns }